
import { mapGetters } from 'vuex';
import compareProductsDisplay from '~/mixins/product-comparison/compareProductsDisplay.js';

export default {
  name: 'ComparisonButton',
  mixins: [compareProductsDisplay],

  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      isHovered: false
    };
  },

  computed: {
    ...mapGetters({
      productsToCompareLength: 'productCompare/productsToCompareLength'
    }),

    addedToComparison() {
      return this.$store.getters['productCompare/containsProductToCompare'](this.data.id);
    },

    productComparisonParam() {
      // const mInsuranceCompany = this.data.insuranceCompany.name.substring(
      //   0,
      //   this.data.insuranceCompany.name.indexOf('|')
      // );
      return {
        category: this.data.category,
        product: {
          id: this.data.id,
          productName: this.data.productName,
          insurnanceName: this.data.insuranceCompany.name,
          logoSrc: this.data.insuranceCompany.logoSrc,
          logoAlt: this.data.insuranceCompany.logoAlt,
          link: this.data.productLink
        },
        showQuantity: this.noOfProductsToDisplay
      };
    },

    isButtonDisabled() {
      return this.productsToCompareLength >= this.noOfProductsToDisplay;
    }
  },

  watch: {
    isButtonDisabled(newVal) {
      if (newVal === true) this.isHovered = false;
    }
  },

  methods: {
    addProductToComparison() {
      this.$store.commit('productCompare/addProductToCompare', this.productComparisonParam);
    }
  }
};
